import React from "react";
import "./Programs.css";
import { programsData } from "../../data/programsData.js";
import rightArrow from "../../assets/rightArrow.png";
const Programs = () => {
  return (
    <div className="Programs" id="programs">
      <div class="programs-header">
        <span class="stroke-text">Explore our</span>
        <span>Programs</span>
        <span class="stroke-text">To shape you</span>
      </div>
      <div className="prgoram-categories">
        {programsData.map((program) => (
          <div className="category">
            {program.image}
            <span>{program.heading}</span>
            <span>{program.details}</span>
            <div className="join-now">
              <span>Join Now</span>
              <img src={rightArrow} alt="" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Programs;
